/* global ViewController, WebView */
var docWorkflowController = new ViewController({
    directory : "views/public",
    name: "docWorkflow",
    container: "main",
    route: "external-doc-form"
}) ;

docWorkflowController.prepareDataOnEnter = function(token, callback){
    this.api.public.getDocForWorkflow(token, function(err, doc){
        if(err){
            if(err === "EXPIRED"){
                return callback(null, { expired: true }) ;
            }
            if(err === "NOT_FOUND"){
                return callback(null, { notfound: true }) ;
            }
            return callback(err) ;
        }

        doc.pdfUrl = "/api/public/getDocWorkflowPdf?token="+token ;
        var query = "" ;
        if(window.location.search){
            query = window.location.search ;
        }
        if(query){
            if(doc.pdfUrl){
                if(doc.pdfUrl.indexOf("?") !== -1){
                    doc.pdfUrl = doc.pdfUrl+query.replace(/^\?/, "&") ;
                }else{
                    doc.pdfUrl = doc.pdfUrl+query ;
                }
            }
        }

        doc.token = token ;

        doc.possibleActions.forEach(function(actionConfig){
            actionConfig.displayCondition = function(doc){
                if(!actionConfig.display_condition){ return true ; }
                return (new Function("doc", "return "+actionConfig.display_condition))(doc) ;
            } ;
        });

        

        callback(null, doc) ;
    }.bind(this)) ;
};

docWorkflowController.onWorkflowAction = function(ev){
    let action = ev.data.data ;
    this.view.updateData() ;
    if(this.data.fieldsToInputByAction[action.action_id]){
        var missingFields = [] ;
        this.data.fieldsToInputByAction[action.action_id].forEach(function(f){
            if(f.required && !this.data[f.field.name]){
                missingFields.push(f.field.field_description) ;
            }
        }.bind(this)) ;
        if(missingFields.length>0){
            return this.view.error(missingFields.map(function(f){
                return f+" : "+WebView.tr("form.requiredField") ;
            }).join("<br />")) ;
        }
    }
    var fields = {} ;
    Object.keys(this.data.fieldsToInput).forEach(function(k){
        var field = this.data.fieldsToInput[k] ;
        fields[field.field.name] = this.data[field.field.name] ;
    }.bind(this)) ;
    this.view.longTask(function(done){
        this.api.public.actionDocForWorkflow(this.data.token, action.action_id, this.data.comment, JSON.stringify(fields), function(err){
            if(err){ return done(err) ; }
            this.view.info(this.view.tr("doc.actionSaved")) ;
            this.data.input_done = true;
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = docWorkflowController ;